import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'

import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

import * as constants from '../../../constants'
import { getBreakpointsEnable, makePath } from '../../../lib';
import { WID } from '../../../constants/Language';
import Word from '../../../containers/Common/Word'
import { useEffect } from 'react'
import { useContext } from 'react'
import { GameContext } from '../GameProvider'
import { Link } from 'react-router-dom'
import { SettingsContext } from '../../../Parts/Settings'
import CustomAvatar from '../../../Parts/CustomAvatar/CustomAvatar'
import { Avatar, Fade } from '@material-ui/core'
import VpnKeyIcon from '@material-ui/icons/VpnKey'
import PersonIcon from '@material-ui/icons/Person'

import { useSize } from 'react-hook-size'
import { useRef } from 'react'


const stylesPlayerBox = (theme) => ({
  root: {
    display: 'block',
    margin: 'auto',
  },
  avatar: {
    width: theme.spacing.unit * 5,
    height: theme.spacing.unit * 5,
    margin: 'auto',
    marginBottom: theme.spacing.unit,
  },
  empty: {
    color: theme.palette.grey[500]
  }
})

const PlayerBox = withStyles(stylesPlayerBox, { withTheme: true })((props) => {
  const { classes, theme, player } = props

  return player ? (
    <div className={classes.root}>
      <CustomAvatar
        alt={player.displayName}
        name={player.displayName}
        src={player.avatarPhotoURL}
        className={classes.avatar}
      />
      <Typography noWrap align='center' className={classes.userName}>{player.userName}</Typography>
    </div>
  ) : (
    <div className={classes.root}>
      <Avatar
        className={classes.avatar}
        style={{
          backgroundColor: theme.palette.grey[100]
        }}
      />
      <Typography noWrap align='center' className={classes.empty}>-</Typography>
    </div>
  )
})

const stylesRuleBox = (theme) => ({
  ruleBox: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  label: {
    color: theme.palette.grey[500],
    fontSize: '0.75rem'
  },
  value: {
    color: theme.palette.grey[700],
    fontSize: '0.75rem'
  }
})


const RuleBox = withStyles(stylesRuleBox, { withTheme: true })((props) => {
  var item, openingRule
  const { classes, room } = props

  item = constants.openingRuleItems.find(item => item.value === room.openingRule)
  openingRule = item !== undefined ? <Word wid={item.wid}/> : undefined
  if (openingRule === undefined) {
    return (<div className={classes.ruleBox}></div>)
  }
  switch (room.gameType) {
    case constants.gameType.LIVE_GAME:
      return (
        <div className={classes.ruleBox}>
          <Grid container spacing={8}>
            <Grid item xs={6}><Typography className={classes.label} align='center'><Word wid={WID.GAME_ROOM_LIST_CARD.OPENING_RULE}></Word></Typography></Grid>
            <Grid item xs={6}><Typography className={classes.value} align='center'>{openingRule}</Typography></Grid>
            <Grid item xs={6}><Typography className={classes.label} align='center'><Word wid={WID.GAME_ROOM_LIST_CARD.TIME}/></Typography></Grid>
            <Grid item xs={6}><Typography className={classes.value} align='center'>{room.minute} <Word wid={WID.GAME_ROOM_LIST_CARD.MINUTE}/></Typography></Grid>
            <Grid item xs={6}><Typography className={classes.label} align='center'><Word wid={WID.GAME_ROOM_LIST_CARD.INCREMENT}/></Typography></Grid>
            <Grid item xs={6}><Typography className={classes.value} align='center'>{room.increaseSecond} <Word wid={WID.GAME_ROOM_LIST_CARD.SECONDS}/></Typography></Grid>
          </Grid>
        </div>
      )
    case constants.gameType.DAILY_GAME:
      return (<div className={classes.ruleBox}></div>
      )
    default:
      return (<div className={classes.ruleBox}>-</div>)
  }
})

const stylesRoomCard = (theme) => ({
  root: {
    textDecoration: 'none',
  },
  card: {
    height: 240,
    margin: 0,
  },
  action: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.grey[500],
    margin: `auto`,
  },
  userCount: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontSize: '0.75rem',
  },
  keyIcon: {
    fontSize: '1rem',
    marginRight: theme.spacing.unit / 2,
  },
  personIcon: {
    fontSize: '1rem',
    marginRight: theme.spacing.unit / 2,
  },
  content: {
    height: '1rem',
    overflow: 'hidden',
  },
  playersGrid: {
    marginBottom: theme.spacing.unit * 2,
  },
})

const RoomCard = withStyles(stylesRoomCard, { withTheme: true })((props) => {
  const { classes, room } = props

  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  return (
    <Link className={classes.root} to={makePath(`/game/${room.groupName}/${room.name}`, language)}>
      <Card className={classes.card}>
        <CardHeader
          subheader={`${room.name}${room.title ? `  ${room.title}` : ''}`}
          action={(
            <React.Fragment>
              {room.lock ? (<VpnKeyIcon className={classes.keyIcon}/>) : undefined}
              {room.users.length > 0 && (                
                <div className={classes.userCount}>
                  <PersonIcon className={classes.personIcon} color='inherit'/>
                  <Typography color='inherit'>{room.users.length}</Typography>
                </div>
              )}
            </React.Fragment>
          )}
          classes={{
            action: classes.action,
            content: classes.content
          }}
        />
        <CardContent>
          <Grid container className={classes.playersGrid}>
            <Grid item xs={6}>
              <PlayerBox player={room.player1}/>
            </Grid>
            <Grid item xs={6}>
              <PlayerBox player={room.player2}/>
            </Grid>
          </Grid>
          <RuleBox { ...{ room }} />
        </CardContent>
      </Card>
    </Link>
  )
})


const stylesGameRoomListCard = theme => ({
  cardHeader: {
    borderBottom: `1px solid ${theme.palette.grey[200]}`
  },
  cardContent: {
    padding: 0,
  },
  grid: {
    display: 'grid',
    gridGap: `${theme.spacing.unit * 2}px`,
  }
})

function GameRoomListCard(props) {
  const { classes, theme, width } = props
  const { xs } = getBreakpointsEnable(theme, width)

  const gameContext = useContext(GameContext)

  const ref = useRef()
  const { width: componentWidth } = useSize(ref)

  var styles = {
    card: {
      marginTop: xs ? theme.spacing.unit : undefined
    },
    grid: {
      gridTemplateColumns:
        componentWidth > 800 ? '1fr 1fr 1fr 1fr' :
        componentWidth > 600 ? '1fr 1fr 1fr' :
        componentWidth > 400 ? '1fr 1fr' : undefined
    }
  }

  useEffect(() => {
    if (gameContext.socket) {
      gameContext.groupsList()
    }
    return () => {
      gameContext.leaveGroup(props.selectedGroup)
      props.unmount()
    }
  },[gameContext.socket])

  return (
    <Fade in={gameContext.rooms.length > 0}>
      <div
        ref={ref}
        className={classes.grid}
        style={styles.grid}
      >
        {gameContext.rooms && gameContext.rooms.map(room => 
          <RoomCard room={room} key={room.name}/>
        )}
      </div>
    </Fade>
  )
}

export default withStyles(stylesGameRoomListCard, { withTheme: true })(GameRoomListCard)



// WEBPACK FOOTER //
// ./src/Pages/Game/components/GameRoomListCard.js